let stack = [] // 记录tab点击顺序

// 初始化
export const initTabStack = () => {
  try {
    stack = JSON.parse(localStorage.getItem('temp_tab_stack')) ?? []
  } catch (e) {
    stack = []
  }
}
// 激活入栈
export const pushTabStack = (pane) => {
  if (stack.includes(pane)) {
    stack.splice(stack.indexOf(pane), 1)
  }
  stack.push(pane)
  saveStack()
  console.log('tab stack push', stack)
}
// 更新栈(清除已关闭的 pane)
const updateTabStack = (items) => {
  const allMenuIds = items.map((item) => item.key)
  stack = stack.filter((item) => allMenuIds.includes(item))
  console.log('tab stack update', stack)
}
const saveStack = () => {
  try {
    localStorage.setItem('temp_tab_stack', JSON.stringify(stack))
  } catch (e) {
    stack = []
  }
}
// 获取栈顶
export const getTagStackTop = (panes) => {
  updateTabStack(panes)
  console.log('tab stack top', stack?.[stack.length - 1])
  // 获取栈顶
  return stack?.[stack.length - 1]
}
